import Vue from 'vue';

export const GlobalEventEmitter = new Vue();
export const makeToast = (payload) => {
    return GlobalEventEmitter.$emit('makeToast', payload);
};
export const updateTalentApplicants = (payload) => {
    GlobalEventEmitter.$emit('updateTalentApplicants', payload);
};
